<ion-header>
  <app-page-header popoverCssClass='teacher-notes'></app-page-header>
  <app-resources-header [title]='"Teacher Blog"' [searchPlaceholder]='"Search Teacher Blog"' (searchTextChanged)='onSearchTextChanged($event)'></app-resources-header> 
</ion-header>

  <ion-content appScrollBounce>
    <div class='bottom'>
      <app-spinner-overlay [spinning]='!viewDisplayed'></app-spinner-overlay>
      <div [hidden]='!viewDisplayed' [ngClass]="['contents', resourcesCssService.responsiveClass()]">

        <div>
          <div class='overview' [innerHTML]="sidebarContent">
            <p>Regular posts to the Blog cover a range of topics including 
              classroom management, PEMs, learning and leading patterns, and much more. 
              Have a topic you’d like us to cover?<br><br>
              Let us know:
              <a href='mailto:teacherblog@musictogether.com'>teacherblog@musictogether.com</a>
            </p>
          </div>
          <app-blog-navigation [hidden]='!viewDisplayed' [articles]=notes [showHeader]="false"></app-blog-navigation>
        </div>

        <div class='items'>
          <div class='list'>
            <ng-container *ngFor='let tool of notes; trackBy: trackByUuid'>
              <app-teaching-tool [tool]='tool' icon='mt-link' *ngIf='!isArticle(tool)'></app-teaching-tool>
              <app-article *ngIf='isArticle(tool)' [article]='tool' icon='mt-document'></app-article>
            </ng-container>
          </div>
          <div class="pagination-buttons" *ngIf='totalPages > 1'>
            <button (click)='previousPage()' [ngClass]=prevClass><i class="fa fa-caret-left"></i></button>
            <div class="page-number">Page <input type="number" [(ngModel)]='currentPage' min="1" max="{{ totalPages }}" /> of {{ totalPages }}</div>
            <button (click)='nextPage()' [ngClass]=nextClass><i class="fa fa-caret-right"></i></button>
          </div>
        </div>
      </div>
    </div>
  </ion-content>